import { render, staticRenderFns } from "./controlAdd.vue?vue&type=template&id=72fd2705&scoped=true"
import script from "./controlAdd.vue?vue&type=script&lang=js"
export * from "./controlAdd.vue?vue&type=script&lang=js"
import style0 from "./controlAdd.vue?vue&type=style&index=0&id=72fd2705&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fd2705",
  null
  
)

export default component.exports